import React, { ChangeEvent, ReactElement, useState } from "react";
import { Button, FormControl, FormGroup } from "react-bootstrap";
import { ProjectTask, useProjects } from ".";
import { ProjectTaskChecklist } from "./ProjectTaskChecklist";

interface IProps {
	task: ProjectTask;
}

export const ProjectTaskAddChecklistForm = (props: IProps): ReactElement => {
	const { task } = props;
	const projectContext = useProjects();

	const [checklist, setChecklist] = useState(new ProjectTaskChecklist());

	const addHandler = () => {
		projectContext.saveAddProjectTaskChecklist!(task, checklist);
	};

	const ChangeListNameHandler = (event: ChangeEvent<HTMLInputElement>) => {
		checklist.name = event.target.value;
		setChecklist({ ...checklist });
	};

	return (
		<div>
			<FormGroup>
				<FormControl
					value={checklist.name ? checklist.name : ""}
					onChange={ChangeListNameHandler}
				/>
			</FormGroup>
			<Button onClick={addHandler}>Add</Button>
		</div>
	);
};
